import moment from "moment";
import { ContractSuspend } from "../../classes";

const ContractSuspendModule = {
    namespaced: true,
    state: {
        contractSuspends: [],
        contractSuspend: {}
    },
    actions: {
        createContractSuspend: async ({ commit, rootGetters, dispatch }, payload) => {
            try {
                Object.assign(payload, { contractId: rootGetters["contract/getContractId"] })
                const newObj = Object.assign({}, payload)
                newObj.startDate = moment(newObj.startDate).startOf("day")
                newObj.endDate = moment(newObj.endDate).endOf("day")
                newObj.issueDate = moment(newObj.issueDate).startOf("day")
                const data = await ContractSuspend.createContractSuspend(newObj);
                dispatch("getContractSuspendByContract")
                return data;
            } catch (err) {
                throw err;
            }
        },
        getContractSuspendByContract: async ({ commit, rootGetters, dispatch }, payload) => {
            try {
                let contractId = payload && payload.contractId ? payload.contractId : rootGetters["contract/getContractId"]
                const data = await ContractSuspend.getContractSuspendByContract({ contractId, isActice: true });
                commit("setContractSuspends", { contractSuspends: data });
                return data;
            } catch (err) {
                throw err;
            }
        },
        getContractSuspend: async ({ commit, rootGetters, dispatch }, payload) => {
            try {
                const data = await ContractSuspend.getContractSuspend(payload);
                commit("setContractSuspend", { contractSuspend: data });
                return data;
            } catch (err) {
                throw err;
            }
        },
        removeContractSuspend: async ({ commit, rootGetters, dispatch }, payload) => {
            try {
                const data = await ContractSuspend.removeContractSuspend(payload);
                dispatch("getContractSuspendByContract")
                return data;
            } catch (err) {
                throw err;
            }
        },
        removedContractSuspend: async ({ commit, rootGetters, dispatch }, payload) => {
            try {
                const data = await ContractSuspend.removedContractSuspend(payload);
                dispatch("getContractSuspendByContract")
                return data;
            } catch (err) {
                throw err;
            }
        },
        editContractSuspend: async ({ commit, rootGetters, dispatch }, payload) => {
            try {
                payload.id = payload.objectId
                payload.startDate = moment(payload.startDate).startOf("day")
                payload.endDate = moment(payload.endDate).endOf('day')
                payload.issueDate = moment(payload.issueDate).startOf("day")
                const data = await ContractSuspend.editContractSuspend(payload);
                dispatch("getContractSuspendByContract");
                return data;
            } catch (err) {
                throw err;
            }
        },
        getContractSuspendBetweenDateByMarket: async ({ commit }, payload) => {
            try {
                const data = await ContractSuspend.getContractSuspendBetweenDateByMarket(payload);
                commit("setContractSuspends", { contractSuspends: data });
                return data;
            } catch (err) {
                throw err;
            }
        },
    },
    getters: {
        getContractSuspend: state => state.contractSuspend,
        getCurrentContractSuspend: state => state.contractSuspends.find(cs=>cs.isActive),
        getContractSuspends: state => state.contractSuspends.sort((a, b) => a.isActive ? -1 : 1)
    },
    mutations: {
        setContractSuspends: (state, payload) => { state.contractSuspends = payload.contractSuspends },
        setContractSuspend: (state, payload) => { state.contractSuspend = payload.contractSuspend }
    }
}
export default ContractSuspendModule;